import module from '../module';

module.directive('focusMe', ['$timeout', function ($timeout) {
    return {
        scope: {
            focusMe: '='
        },
        link: function ($scope, element) {
            $scope.$watch('focusMe', (newValue) => {
                if (newValue === 0) {
                    return;
                }
                $timeout(() => {
                    element[0].focus();
                }, 800);
            });
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/modules/shared/directives/FocusMeDirective.js